import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const [tab, setTab] = useState("login");
  const navigate = useNavigate();

  return (
    <main style={{ background: "#f8fafc", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px" }}>
      <div style={{ background: "white", borderRadius: "20px", boxShadow: "0 8px 40px rgba(0,0,0,0.08)", width: "100%", maxWidth: "440px", overflow: "hidden" }}>

        {/* HEADER */}
        <div style={{ background: "linear-gradient(135deg, #16a34a, #0d7a3a)", padding: "32px", textAlign: "center" }}>
          <h1 style={{ fontFamily: "'Sora', sans-serif", fontSize: "24px", fontWeight: "900", color: "white", margin: "0 0 6px" }}>
            Ecoconnect
          </h1>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "13px", fontFamily: "'DM Sans', sans-serif", margin: 0 }}>
            India's #1 Energy Market e-HUB
          </p>
        </div>

        {/* TABS */}
        <div style={{ display: "flex", borderBottom: "1px solid #e5e7eb" }}>
          {["login", "register"].map((t) => (
            <button key={t} onClick={() => setTab(t)}
              style={{
                flex: 1, padding: "14px",
                fontFamily: "'Sora', sans-serif",
                fontSize: "13px", fontWeight: "700",
                cursor: "pointer", border: "none",
                background: "white",
                color: tab === t ? "#16a34a" : "#9ca3af",
                borderBottom: tab === t ? "2.5px solid #16a34a" : "2.5px solid transparent",
                transition: "all 0.2s",
                textTransform: "capitalize",
              }}>
              {t === "login" ? "Login" : "Register"}
            </button>
          ))}
        </div>

        {/* FORM */}
        <div style={{ padding: "32px" }}>
          {tab === "login" ? (
            <>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Email Address</label>
                <input type="email" placeholder="you@company.com"
                  style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                  onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Password</label>
                <input type="password" placeholder="••••••••"
                  style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                  onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <button style={{ width: "100%", padding: "13px", background: "#16a34a", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "700", fontFamily: "'Sora', sans-serif", cursor: "pointer" }}>
                Login ➜
              </button>
              <p style={{ textAlign: "center", fontSize: "12px", color: "#9ca3af", fontFamily: "'DM Sans', sans-serif", marginTop: "16px" }}>
                Don't have an account?{" "}
                <span onClick={() => setTab("register")} style={{ color: "#16a34a", fontWeight: "700", cursor: "pointer" }}>Register here</span>
              </p>
            </>
          ) : (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "16px" }}>
                <div>
                  <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>First Name</label>
                  <input type="text" placeholder="Aryan"
                    style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                    onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Last Name</label>
                  <input type="text" placeholder="Sharma"
                    style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                    onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Email Address</label>
                <input type="email" placeholder="you@company.com"
                  style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                  onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Phone Number</label>
                <input type="tel" placeholder="+91 XXXXX XXXXX"
                  style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                  onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ fontSize: "12px", fontWeight: "700", color: "#374151", fontFamily: "'Sora', sans-serif", display: "block", marginBottom: "6px" }}>Password</label>
                <input type="password" placeholder="••••••••"
                  style={{ width: "100%", padding: "11px 14px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", outline: "none", boxSizing: "border-box" }}
                  onFocus={(e) => e.target.style.borderColor = "#16a34a"}
                  onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>
              <button style={{ width: "100%", padding: "13px", background: "#16a34a", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "700", fontFamily: "'Sora', sans-serif", cursor: "pointer" }}>
                Create Account ➜
              </button>
              <p style={{ textAlign: "center", fontSize: "12px", color: "#9ca3af", fontFamily: "'DM Sans', sans-serif", marginTop: "16px" }}>
                Already have an account?{" "}
                <span onClick={() => setTab("login")} style={{ color: "#16a34a", fontWeight: "700", cursor: "pointer" }}>Login here</span>
              </p>
            </>
          )}
        </div>

      </div>
    </main>
  );
}

export default Login;